import { useQuery } from '@tanstack/react-query';
import { getDiscourseAvailableUsername } from '@wellstone-solutions/api/v2';

export function useCheckUsername(username: string) {
  const { data: available, isLoading: checking } = useQuery({
    queryKey: ['checkUsername', username],
    queryFn: async () => {
      if (!username) return null;
      const res = await getDiscourseAvailableUsername({ username });
      return res.data?.available ?? null;
    },
    enabled: username.length > 3,
    // Delay to prevent too many requests while typing
    staleTime: 400,
  });

  return { available, checking };
}
